import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "HERO_EQUITY",
  title: defineMessage({ id: "fig.equity.HERO.title", defaultMessage: `Equity` }),
  caption: defineMessage({
    id: "fig.equity.HERO.caption",
    defaultMessage: `For every 100 of the richest young people who complete upper secondary school, only 11 of the poorest do so in low-income countries.`,
  }),
  source: defineMessage({ id: "fig.equity.HERO.source", defaultMessage: `UIS database` }),
};
